import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24a282d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "me-2 d-flex align-center"
}
const _hoisted_3 = {
  key: 1,
  class: "ms-2 d-flex align-center"
}

import { withDefaults, computed } from 'vue';

interface IProps {
  classes?: string;
  text?: string;
  background?: string;
  color?: string;
  outlineColor?: string;
  hoverColor?: string;
  prependIcon?: boolean;
  outlined?: boolean;
  appendIcon?: boolean;
  disabled?: boolean;
  noHover?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomButton',
  props: {
    classes: {},
    text: {},
    background: {},
    color: {},
    outlineColor: {},
    hoverColor: {},
    prependIcon: { type: Boolean },
    outlined: { type: Boolean },
    appendIcon: { type: Boolean },
    disabled: { type: Boolean, default: false },
    noHover: { type: Boolean, default: false }
  },
  setup(__props: any) {

const classButton = computed(() => {
  return `color-button  d-flex justify-center align-center ${!props.noHover && !props.disabled ? 'isHover' : ''} ${
    props.outlined ? 'btn-outlined hover-outline' : ''
  } ${props.outlineColor ? props.outlineColor : ''} ${props.classes}`;
});
const colorHover = computed(() => {
  return props.hoverColor ? `${props.hoverColor}` : 'var(--color-gray-500)';
});
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: props.disabled,
    class: _normalizeClass(classButton.value)
  }, [
    (props.prependIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "prependIcon")
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.appendIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "appendIcon")
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})